import { Kanban } from '../../../_services/kanban/kanban.model'

export class KanbanColumn {
  constructor(
    readonly phaseId: string,
    readonly cards: Kanban.Card.Entity[],
    readonly totalCount: number,
    readonly hasMore: boolean
  ) {}

  get offset(): number {
    return this.cards.length
  }

  hasCard(cardId: string): boolean {
    return this.cards.some(c => c.id === cardId)
  }

  appendCards(newCards: Kanban.Card.Entity[], hasMore: boolean): KanbanColumn {
    return new KanbanColumn(this.phaseId, [...this.cards, ...newCards], this.totalCount, hasMore)
  }

  replaceCard(card: Kanban.Card.Entity): KanbanColumn {
    const index = this.cards.findIndex(c => c.id === card.id)
    if (index === -1) return this
    const updated = [...this.cards]
    updated[index] = card
    return new KanbanColumn(this.phaseId, updated, this.totalCount, this.hasMore)
  }

  removeCard(cardId: string): KanbanColumn {
    return new KanbanColumn(
      this.phaseId,
      this.cards.filter(c => c.id !== cardId),
      this.totalCount - 1,
      this.hasMore
    )
  }

  prependCard(card: Kanban.Card.Entity): KanbanColumn {
    return new KanbanColumn(this.phaseId, [card, ...this.cards], this.totalCount + 1, this.hasMore)
  }
}
